// Components
import DataDisplayRow from './DataDisplayRow'
import CompanyUserForm from './forms/CompanyUserForm'
import { submitEditForm } from '../companyUsersHelpers'
import { updateCompanyUser, closeEditForm } from '../actions/companyUsers'

const ActiveUserTableRow = ({ companyUsersInEditModeIds, companyUser, companyUsersUrl, isAgency, dispatch }) => {
  const editMode = companyUsersInEditModeIds.includes(companyUser.id)
  return (
    editMode ?
      <CompanyUserForm companyUser={companyUser}
        isAgency={isAgency}
        submitFormHandler={({ event }) => submitEditForm({
          event,
          submitUrl: `${companyUsersUrl}/${companyUser.id}`,
          companyUserId: companyUser.id,
          onSuccess: compUser => dispatch(updateCompanyUser(compUser))
        })}
        closeFormHandler={e => dispatch(closeEditForm(companyUser.id))} /> :
      <DataDisplayRow companyUser={companyUser} />
  )
}
const mapStateToProps = ({ companyUsersUrl, companyUsersInEditModeIds, isAgency }) => ({
  companyUsersUrl,
  companyUsersInEditModeIds,
  isAgency
})
export default connect(mapStateToProps)(ActiveUserTableRow)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/ActiveUserTableRow.js